var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('img',{attrs:{"src":_vm.url,"id":"image"}}):_c('img',{attrs:{"src":"assets/layout/images/no-image.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }